/* eslint-disable no-unused-vars */
import { Delete, Get, Post, PostFormData, Put } from "../Request";

export default {
  state: {
    Sales: [],
  },
  getters: {
    GetSales(state) {
      return state.Sales;
    },
  },
  actions: {
    async GetAllOrder({ commit }, payload = {}) {
      let {
        pageNumber = 1,
        pageSize = 10,
        OrderCode = "",
        date = "",
        status = "",
        IsArchieve = false,
      } = payload;

      // const apiUrl = `Store/GetAllOrders?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${OrderCode}&OrderDate=${OrderDate}&status=${status}&IsArchieve=${IsArchieve}`;
      const apiUrl = `Store/GetAllSalesAndOrdes?pageNumber=${pageNumber}&pageSize=${pageSize}&search=${OrderCode}&date=${date}&status=${status}&IsArchieve=${IsArchieve}`;

      return await Get(apiUrl).then((res) => {
        commit("SetSales", res.data.Data);
        return res.data.Data;
      });
    },
    async ChangeOrderStatus({ commit }, payload) {
      return await Put(
        `Store/ChangeOrderStatus?orderCode=${payload.orderCode}&&status=${payload.status}`
      ).then((res) => {
        return res.data;
      });
    },
    async EditOrderAdminNote({ commit }, payload) {
      return await Put(
        `Store/EditOrderAdminNote`,payload
      ).then((res) => {
        return res.data;
      });
    },
    async EditShippingDetails({ commit }, payload) {
      return await Put(
        `Store/EditShippingDetails`,payload
      ).then((res) => {
        return res.data;
      });
    },
    async ChnageArchieveStatus({ commit }, payload) {
      return await Put(
        `Store/ChangeArchieveStatus?ordercode=${payload.ordercode}`
      ).then((res) => {
        return res.data;
      });
    },
    async DeleteStoreCartItem({ commit }, payload) {
      return await Delete(
        `Store/DeleteStoreCartItem?ordercode=${payload.orderCode}`)
    },
  },
  mutations: {
    SetSales(state, payload) {
      // console.log("payload ",payload.list)
      payload.list.forEach((item) => {
        if (item.Items && item.Items.length > 0 ) {
          item.isOrderDate = item.Items[0].OrderDate?.split("T")[0];
          item.PaymentType = item.Items[0]?.Payment?.PaymentType === 1 ? "Card" : "Paypal";
          item.InvoiceStatus = item.Items[0]?.InvoiceStatus === 2
                  ? "NEW"
                  : item.Items[0]?.InvoiceStatus === 3
                  ? "RECEIVED"
                  : item.Items[0]?.InvoiceStatus === 4
                  ? "SHIPPED"
                  : item.Items[0]?.InvoiceStatus === 5
                  ? "INVOICED"
                  : "VOID";
          item.Amount = item.Items[0]?.Payment?.Price?.toFixed(2);
          item.UserName = item.Items[0]?.IsUser
                  ? item.Items[0]?.User?.FirstName +
                    " " +
                    item.Items[0]?.User?.LastName
                  : "Guest User";
          item.TrackingId = item.Items[0]?.TrackingId
        }
      });
      state.Sales = payload;
    },
  },
};
